import React, { useEffect } from "react";
import SharedCalendar from "../../components/Shared/SharedCalendar";
import { Calendar } from "primereact/calendar";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import i18next from "i18next";

import PageHeader from '../../components/Shared/PageHeader'
import DatePicker from '../../components/Shared/DatePicker'
import TextInput from '../../components/Shared/TextInput'
import DropdownComponent from '../../components/Shared/DropdownComponent'
import { FaCheckDouble } from 'react-icons/fa6'
import SharedButton from "../../components/Shared/SharedButton";
import {
  CreateNewPurchasedPayment,
  getPurchasedEntryList,
} from "../../store/slices/PurchaseSlice";
import { getCashBankAccounts } from "../../store/slices/AcountsSlice";

export default function ReceivePaymentPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const lang = i18next.language;
  const { t } = useTranslation();
  const { isLoading } = useSelector((state) => state.purchase);
  const { cashBankAccounts } = useSelector((state) => state.acount);

  const selectedEntries = location.state?.selectedEntries || [];

  const listAccountsvalues = cashBankAccounts?.data
    ? Object.entries(cashBankAccounts.data).map(([id, account]) => ({
      id: Number(account?.code),
      name: lang === "ar" ? account.name_ar : account.name_en,
    }))
    : [];

  function convertData(data) {
    const datatoreturn = data?.map((dt) => ({
      purchase_id: dt.id,
      total_amount: dt.total_amount,
    }));
    return datatoreturn;
  }

  const initialValues = {
    data: convertData(selectedEntries),
    payment_date: "",
    payment_method: "",
    account_code: "",
    notes: "",
  };

  const validationSchema = Yup.object().shape({
    payment_date: Yup.string().required(t("required")),
    payment_method: Yup.string().required(t("required")),
    account_code: Yup.string().required(t("required")),
    notes: Yup.string().required(t("required")),
  });

  const paymentOption = [
    { value: "cash", label: lang === "ar" ? "نقدي" : "Cash" },
    { value: "bank", label: lang === "ar" ? "بنك" : "Bank" },
    { value: "mada", label: lang === "ar" ? "مدى" : "MADA" },
    { value: "cheque", label: lang === "ar" ? "يفحص" : "Cheque" },
  ];

  useEffect(() => {
    dispatch(getCashBankAccounts());
  }, [dispatch]);

  const onSubmit = async (values, { resetForm }) => {
    try {
      const resultAction = await dispatch(CreateNewPurchasedPayment(values));
      if (resultAction?.meta?.requestStatus === "fulfilled") {
        resetForm();
        dispatch(getPurchasedEntryList({ page: 1, per_page: 10 }));
        navigate(-1); // Navigate back after successful submission
      }
    } catch (error) {
      console.error("Error creating payment:", error);
    }
  };

  return (
    <div className="flex flex-col w-full gap-2 max-h-[calc(100vh-150px)]">
      <PageHeader title={t("RecordPayment")} backPath={'/manager/purchased_entry'} />

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm }) => {
          // Format date to YYYY-MM-DD
          let formattedDate = values.payment_date;
          if (values.payment_date instanceof Date) {
            const year = values.payment_date.getFullYear();
            const month = String(values.payment_date.getMonth() + 1).padStart(2, '0');
            const day = String(values.payment_date.getDate()).padStart(2, '0');
            formattedDate = `${year}-${month}-${day}`;
          }
          
          const payload = { ...values, payment_date: formattedDate };
          await onSubmit(payload, { resetForm });
        }}
      >
        {(formik) => (
          <Form onSubmit={formik.handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2 w-full">
              <DatePicker
                name="payment_date"
                label={t("payment_date")}
                placeholder={t("enter")}
                dateFormat="yy-mm-dd"
              />

              <DropdownComponent
                label={t("paymentMethod")}
                placeholder={`${t("select")} ${t("paymentMethod")}`}
                name="payment_method"
                options={paymentOption}
                filter
              />

              <DropdownComponent
                label={`${t("cashBank")} ${t("account")}`}
                name="account_code"
                options={listAccountsvalues}
                placeholder={`${t("select")} ${t("account")}`}
                filter
              />

              <TextInput
                label={t("description")}
                name="notes"
                placeholder={`${t("enter")} ${t("description")}`}
                error={formik.touched.notes && formik.errors.notes}
              />
            </div>

            <div className="flex justify-end gap-2">
              <SharedButton
                type="button"
                icon="pi pi-times"
                label={t("Cancel")}
                buttonType='reset'
                onClick={() => {
                  navigate('/manager/purchased_entry');
                }}
              />
              <SharedButton
                type="submit"
                icon={<FaCheckDouble size={12} className='me-2' />}
                loading={isLoading}
                disabled={isLoading}
                label={t("Submit")}
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
